import { Box } from '@mui/material';

import FairlyBackgroundLogo from '@/ui/assets/logo-fairly-background.png';
import { translate } from '@/ui/i18n';
import { ColorsRaw } from '@/ui/theme/colors-raw';

export function PageProjectHeaderImage({ image }: { image: string }) {
  return (
    <Box sx={{ width: 200, minWidth: 200, height: 140 }}>
      {image ? (
        <img
          src={image}
          alt={translate('Projects.project-image')}
          style={{
            objectFit: 'cover',
            width: '100%',
            height: '100%',
            borderRadius: 10,
          }}
        />
      ) : (
        <img
          src={FairlyBackgroundLogo}
          alt={translate('Projects.project-image')}
          style={{
            padding: 10,
            objectFit: 'contain',
            width: '100%',
            height: '100%',
            borderRadius: 10,
            backgroundColor: ColorsRaw.anthracite.Anthracite_2,
          }}
        />
      )}
    </Box>
  );
}
